<template>
    <div
        class="c-view c-activities-calendar"
        v-bind:class="{ fullscreen: isFullscreen }"
    >
        <InternalHeader>
            <div slot="title" class="c-internal-header__title">
                Task Calendar
            </div>
            <ownership-toggle
                slot="actions"
                v-bind:value.sync="owner"
            ></ownership-toggle>
        </InternalHeader>
        <Row class="mt-5">
            <Col span="24">
                <activities-calendar
                    :activities="activities"
                    :isFullscreen="isFullscreen"
                    :dateRange="dateRange"
                    v-on:update:isFullscreen="isFullscreen = $event"
                    v-on:update:dateRange="dateRange = $event"
                    @updateActivity="updateActivity"
                ></activities-calendar>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
    props: {
        activitiesRepository: Object,
    },
    components: {
        ActivitiesCalendar: function() {
            return import("@/js/components/partials/activities-calendar");
        },
        InternalHeader: function() {
            return import("@/js/components/partials/header");
        },
        OwnershipToggle: function() {
            return import("@/js/components/partials/tasks-ownership-toggle");
        },
    },
    data() {
        return {
            activities: [],
            isFullscreen: false,
            dateRange: {},
            owner: "all",
            localStorageKeyOwner: "activities_owner",
        };
    },
    created() {
        this.initializeOwner();
    },
    mounted() {
        /**
         * Listen for changes to any activity that might be in our list
         */
        this.$root.$on("activity:deleted", this.removeActivity);
        this.$root.$on("activity:updated", this.replaceActivity);
    },
    watch: {
        activities: {
            handler() {
                this.activities.map((element) => {
                    element.start = element.scheduled_at;
                    element.backgroundColor = this.eventColor(
                        element.status_id
                    );
                    element.borderColor = this.eventColor(element.status_id);
                    return element;
                });
            },
            deep: true,
        },
        dateRange: {
            handler() {
                this.query();
            },
            deep: true,
        },
    },
    methods: {
        initializeOwner() {
            var owner = this.$localStorageCache.get(this.localStorageKeyOwner);
            this.owner = owner || "owner"; // mine, unassigned
            this.$watch("owner", this.onOwnerChange, { deep: true });
        },
        onOwnerChange() {
            this.$localStorageCache.set(this.localStorageKeyOwner, this.owner);
            this.activities = [];
            this.query();
        },
        eventColor(statusId) {
            switch (statusId) {
                case 1:
                    return "#007aff"; // pending / @primary-color
                    break;
                case 2:
                    return "#62e442"; // completed / @success-color
                    break;
                case 4:
                    return "#ff6c4c"; // failed / @error-color
                    break;
                case 6:
                    return "#ffd434"; // message queued / @warning-color
                case 5:
                default:
                    return "#8b8c8b"; // skipped / @gray-background-dark-opaque;
                    break;
            }
        },
        async query() {
            // Wait until we have a date range (calendar loads)
            if (!("start" in this.dateRange) || !("end" in this.dateRange)) {
                return;
            }

            this.activities = [];

            let request = {
                params: {
                    q: [
                        "status_id[in]=1,2,5",
                        "parent_activity_id[null]",
                        "scheduled_at[gte]=" + this.dateRange.start,
                        "scheduled_at[lt]=" + this.dateRange.end,
                    ],
                    include: ["playbookAction.playbook", "account", "contact"],
                    page: 1,
                    per_page: 100,
                },
            };

            // Append ownership filter
            if (this.owner == "owner") {
                request.params.q.push(
                    "assigned_to_id[eq]=" + this.$store.getters["me/ID"]
                );
            }

            let finished = false;
            let response;
            while (!finished) {
                response = await this.activitiesRepository.index(request);
                this.activities.push(...response.data.data);
                finished = _.get(response, "data.links.next") ? false : true;
                ++request.params.page;
            }
        },
        replaceActivity(activity) {
            let index = this.activities.findIndex(
                (oldActivity) => oldActivity.id == activity.id
            );
            if (index >= 0) this.activities.splice(index, 1, activity);
        },
        async updateActivity(payload) {
            var response = await this.activitiesRepository.update(
                payload.id,
                payload
            );

            this.$Message.success({
                content: "Activity Saved.",
            });
        },
        async removeActivity(activityId) {
            let index = this.activities.findIndex(
                (activity) => activity.id == activityId
            );
            this.activities.splice(index, 1);
        },
    },
};
</script>
